import { MediaSourceType } from '../../types';
export function getTransKeyForMediaSourceType(mediaSource = MediaSourceType.COLLECTION) {
    const mediaSourceTypeToLabelMap = {
        [MediaSourceType.GALLERY]: 'mediapopup.myGalleries',
        [MediaSourceType.COLLECTION]: 'mediapopup.myCollections',
        [MediaSourceType.PRIVATE_COLLECTION]: 'mediapopup.myPrivateCollections',
        [MediaSourceType.STASH]: 'mediapopup.myStash',
        [MediaSourceType.BROWSE]: 'mediapopup.browse',
        [MediaSourceType.POLL]: 'mediapopup.myPolls',
        [MediaSourceType.STATUS]: 'mediapopup.myStatuses',
        [MediaSourceType.JOURNAL]: 'mediapopup.myJournals',
        [MediaSourceType.POSTS]: 'mediapopup.myPosts',
        [MediaSourceType.TIER]: 'mediapopup.tiers',
        [MediaSourceType.TIER_DEVIATIONS]: 'mediapopup.tierDeviations',
        [MediaSourceType.TIER_POSTS]: 'mediapopup.tierPosts',
        [MediaSourceType.COMMISSIONS]: 'mediapopup.commissions'
    };
    return mediaSourceTypeToLabelMap[mediaSource];
}
export function getAllMediaSourceTypes() {
    return [
        MediaSourceType.GALLERY,
        MediaSourceType.COLLECTION,
        MediaSourceType.STASH,
        MediaSourceType.BROWSE,
        MediaSourceType.POLL,
        MediaSourceType.STATUS,
        MediaSourceType.JOURNAL,
        MediaSourceType.POSTS,
        MediaSourceType.COMMISSIONS
    ];
}

//# sourceMappingURL=_helpers.js.map